<template>
  <div class="staff">
    <ul class="newsUl2 wow animate__slideInUp">
      <li :key="idx" v-for="(item, idx) in newsList">
        <router-link :to="`/newsContent?id=${item.Id}`">
          <div class="item">
            <div class="item_pic">
              <div
                class="pimg"
                :style="{
                  'background-image':
                    'url(' + (item.PicUrl || defaultPicUrl) + ')',
                }"
              >
                <img src="@/assets/images/bg_news.png" alt="" width="100%" />
              </div>
            </div>
            <div class="item_tit">
              {{ item.Title }}
            </div>
            <div class="item_desc">
              {{ item.Summary }}
            </div>
            <div class="item_date">
              {{ moment(item.PubDate).format("YYYY-MM-DD") }}
            </div>
          </div>
        </router-link>
      </li>
      <!-- <li class="animate__animated animate__slideInUp animate__delay-1s">
        <a href="">
          <span>青海省政协副主席张晓容一行莅临 西宁公司指导调研</span>
          <span>2022-02-20</span>
          <span class="newMore">{{actionTxt||'查看'}}</span>
        </a>
      </li>
      <li class="animate__animated animate__slideInUp animate__delay-2s">
        <a href="">
          <span>青海省政协副主席张晓容一行莅临 西宁公司指导调研</span>
          <span>2022-02-20</span>
          <span class="newMore">{{actionTxt||'查看'}}</span>
        </a>
      </li> -->
    </ul>
    <!-- <div class="pageBox">
      <Pagenation />
    </div> -->
  </div>
</template>

<script>
import Pagenation from "./Pagenation";

export default {
  data() {
    return {
      moment: this.$moment,
      defaultPicUrl:
        "http://www.zfsycf.com.cn/ueditor/net/upload/image/20230429/6381836262292756476458537.jpg",
    };
  },
  props: ["actionTxt", "newsList", "down", "lang"],
  components: {
    Pagenation,
  },
};
</script>

<style lang="scss">
.staff {
  overflow: hidden;
  // min-height: 200px;
  ul {
    margin: 0 -8px;
    border-top: 0;
  }
  li {
    width: 33.33%;
    float: left;
    padding: 0;
    border: 0;
    a {
      display: block;
    }
    .item {
      margin:8px;
      font-size:16px;
      width: 100%;
      padding: 15px;
      font-weight: normal;
      .item_pic {
        margin-bottom: 25px;
        overflow: hidden;
        .pimg {
          position: relative;
          background-repeat: no-repeat;
          background-size: cover;
          transition: 0.3s;
          -moz-transition: 0.3s;
          -webkit-transition: 0.3s;
        }
      }
      .item_tit {
        font-size:18px;
        font-weight: bold;
        line-height: 1.3;
        height:2.6em;
        color:#333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp:2;
      }
      .item_desc {
        line-height: 1.4;
        height:2.8em;
        margin:15px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp:2;
      }
      .item_date {
        font-size:15px;
        color: #595757;
      }
      &:hover {
        .pimg {
          -webkit-transform: scale(1.1);
          transform: scale(1.1);
          -moz-transform: scale(1.1);
        }
      }
    }
    &:hover {
      background: none;
      .item {
        background: #f9f9f9;
      }
    }
  }
}
.pageBox {
  padding: 40px 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #d71820 !important;
}
@media (max-width: 980px) {
  .staff li {
    width: 100%;
  }
}
</style>
